import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
  CheckBox,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import {
  transformTranslateFromValues,
  transformTranslateServerValues,
  dateTimeToserver,
} from "lib/helpers";
import Modal from "components/Modal";
import { useCore } from "store/core";
import { TextArea } from "components/form";
import cleanObject from "utils/editHelper";
import { GalleryField } from "components/form";
import { CkEditorFull } from "components/form";
import MyFormComponent from "utils/DynamicEntityTypeFields";
import initItem from "utils/initItem";
import extractValues from "utils/extractValues";
import TextFieldSlug from "components/form/TextFieldSlug";
import MultiselectAdd from "components/form/MultiSelectAdd";
import SearchSelect from "utils/SearchSelect";
// components

export default function Edit(props) {
  const core = useCore();
  const { show, item } = props;

  // if (item?.categories?.length) {
  //   const categoryIds = item?.categories?.map((category) => category.id);
  //   console.log("categoryIds: ", categoryIds);
  //   item.categories = categoryIds;
  // }

  const initialValues = {
    ...item,
  };

  const config = {
    match: {
      valueField: "id",
      labelFields: [
        "homeTeam.translations.fa.name",
        "awayTeam.translations.fa.name",
      ],
    },
  };
  const updatedItem = initItem(initialValues, config);

  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={updatedItem}
          onSubmit={async (values, { setSubmitting }) => {
            if (values.publishedAt)
              values.publishedAt = dateTimeToserver(
                values.publishedAt,
                "YYYY-MM-DD"
              );

            const clean = cleanObject(values, [
              "id",
              "updatedAt",
              "uuid",
              "createdAt",
              "author",
            ]); //ok

            const result = extractValues(clean);

            await props.submit(result, item.id);
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="عنوان"
                    label="عنوان :"
                    name="translations.fa.title"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="عنوان(en)"
                    label="عنوان (en):"
                    name="translations.en.title"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />

                  <div className="intro-y">
                    <Field
                      label="نامک:"
                      name="translations.fa.slug"
                      component={TextField}
                    />
                  </div>
                  <div className="intro-y">
                    <Field
                      label="نامک انگلیسی:"
                      name="translations.en.slug"
                      component={TextField}
                    />
                  </div>
                </div>
                <br />

                <div className="mt-10">
                  <Field
                    placeholder="لینک"
                    label="لینک:"
                    name="link"
                    component={TextField}
                  />
                  <Field
                    label="آیا برنامه ثابت است؟"
                    name="isFixedProgram"
                    component={CheckBox}
                  />
                </div>

                <div className="w-full flex justify-between mt-10">
                  <div className="w-full">
                    <Field
                      label="لوگو"
                      name="logo"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <div className="w-full flex justify-between mt-10">
                  <div className="w-full">
                    <Field
                      label="پس زمینه"
                      name="backGround"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

